export default {"src":"/_next/static/media/crosshair.b0cee879.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};